import { QueryFunction, useInfiniteQuery } from '@tanstack/react-query';
import { OptionsPage, OptionType } from './types';

export const useInfiniteSearchQuery = <T extends OptionType>(
  queryKey: string[],
  queryFn: QueryFunction<OptionsPage<T>, any, any>,
  term: string,
  options?: any
) =>
  useInfiniteQuery({
    queryKey: queryKey.concat(term, options),
    queryFn,
    meta: {
      ...options,
      searchText: term,
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage: OptionsPage<T>) =>
      lastPage.last ? null : lastPage.number + 1,
  });
